import { render, staticRenderFns } from "./EventManagementWrapper.vue?vue&type=template&id=6d2f36bd"
import script from "./EventManagementWrapper.vue?vue&type=script&lang=js"
export * from "./EventManagementWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports